import { StompActionskeys } from "../stomp-broker";
import { of } from "rxjs/observable/of";
import { getErrorMessage } from "../helpers/errorParser";
import { ItemStatus } from "@focus/interfaces/lib/common/itemFetchStatus";
import { ServerStatusTypes, } from "@focus/interfaces/lib/status/Status";
import { Observable } from "rxjs/Observable";
export const autofocusServerID = "autofocusServerUp";
export const eventsLoggerServerID = "eventsLoggerServerUp";
export const focusServerID = "focusServerUp";
export const listenToPanelChangesEpic = (actions$, _, { stomp }) => actions$.ofType(StompActionskeys.CONNECTED).mergeMap(() => stomp
    .subscribe(`/topic/focus/status`)
    .mergeMap((res) => {
    switch (res.type) {
        case ServerStatusTypes.AUTOFOCUS_SERVER_DOWN:
            return Observable.of(setStatus(autofocusServerID, false));
        case ServerStatusTypes.AUTOFOCUS_SERVER_UP:
            return Observable.of(setStatus(autofocusServerID, true));
        case ServerStatusTypes.EVENTS_LOGGER_SERVER_DOWN:
            return Observable.of(setStatus(eventsLoggerServerID, false));
        case ServerStatusTypes.EVENTS_LOGGER_SERVER_UP:
            return Observable.of(setStatus(eventsLoggerServerID, true));
        case ServerStatusTypes.FOCUS_SERVER_DOWN:
            return Observable.of(setStatus(focusServerID, false));
        case ServerStatusTypes.FOCUS_SERVER_UP:
            return Observable.of(setStatus(focusServerID, true));
        default:
            return Observable.throw({ message: "Invalid message received" });
    }
})
    .takeUntil(actions$.ofType(StompActionskeys.DISCONNECTED).take(1)));
export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["SET_STATUS"] = "STATUS_SET_STATUS";
    ActionTypes["SET_PENDING"] = "STATUS_SET_PENDING";
    ActionTypes["SET_ERROR"] = "STATUS_SET_ERROR";
})(ActionTypes || (ActionTypes = {}));
export const setStatus = (key, status) => ({
    type: ActionTypes.SET_STATUS,
    payload: { [key]: status },
});
export const setMultipleStatus = (statuses) => ({
    type: ActionTypes.SET_STATUS,
    payload: statuses,
});
export const setFetchStatusPending = () => ({ type: ActionTypes.SET_PENDING });
export const setFetchStatusError = (error) => ({
    type: ActionTypes.SET_ERROR,
    payload: error,
});
const initialState = {
    status: {},
    fetchStatus: ItemStatus.PENDING,
};
export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.SET_STATUS:
            const payload = action.payload;
            return Object.assign(Object.assign({}, state), { fetchStatus: ItemStatus.READY, status: Object.assign(Object.assign({}, state.status), payload) });
        case ActionTypes.SET_ERROR:
            return Object.assign(Object.assign({}, state), { fetchStatus: ItemStatus.ERROR });
        case ActionTypes.SET_PENDING:
            return Object.assign(Object.assign({}, state), { fetchStatus: ItemStatus.PENDING });
        default:
            return state;
    }
};
export const getStatus = (state, key) => state.status[key] || false;
export const getFetchStatus = (state) => state.fetchStatus;
export const ServerStatusEpic = (actions$, _, { ajax }) => actions$.ofType(StompActionskeys.CONNECTED).mergeMap(() => ajax
    .getJSON(`/api/v1/status`)
    .map((response) => setMultipleStatus(response))
    .catch((error) => of(setFetchStatusError(getErrorMessage(error))))
    .startWith(setFetchStatusPending(), setStatus(NetworkStatusId, true)));
export const NetworkStatusId = "networkServerUp";
export const ServerDisConnectionStatusEpic = (actions$) => actions$
    .ofType(StompActionskeys.DISCONNECTED)
    .map(() => setStatus(NetworkStatusId, false));
export const middleware = [
    ServerStatusEpic,
    ServerDisConnectionStatusEpic,
    listenToPanelChangesEpic,
];
export const createStatus = () => {
    return { actions: {}, selectors: {}, reducer, middleware };
};
//# sourceMappingURL=index.js.map